import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Typography } from "@mui/material";
import ValueCounter from "../ValueCounter";
import AutoScrollAccordion from "../AutoScrollAccordion";
import * as Styled from "./styles.js";

// SpacingControl — GORDON DESIGN STANDARD 2026-09-15 (gordon-0915-law-shared-
// spacing-control-one-row-steppers): the ONE control every block settings
// pane uses for its Padding section and its Margin section. Replaces the old
// per-block 2x2 minus/plus grid (MarginBox/PaddingBox's own RowDiv, and
// controls.jsx's QuadStepper) with a single row of four compact Top / Bottom
// / Left / Right steppers under a collapsible "<Label> (i)" header. There is
// intentionally no "apply to all sides" checkbox/slider path — every side is
// always independently editable.
const SIDES = ["Top", "Bottom", "Left", "Right"];

const SpacingControl = ({
  label,
  tooltipDescription,
  value = { top: 0, bottom: 0, left: 0, right: 0 },
  onChange = () => {},
  fullWidth = false,
  onlyVerticalMargins = false,
  min = 0,
  max = 100,
  containerStyle = {},
  AccordionContainerStyle = {},
  applyButton = false,
  onApplyClick = () => {},
}) => {
  const visibleSides = onlyVerticalMargins
    ? ["Top", "Bottom"]
    : SIDES.filter((side) => !(fullWidth && (side === "Left" || side === "Right")));

  return (
    <div>
      <AutoScrollAccordion
        title={label}
        AccordionSummaryStyle={{ p: 0, m: 0 }}
        AccordionContainerStyle={AccordionContainerStyle}
        RightIconComponent={ExpandMoreIcon}
        isTootTipShow={!!tooltipDescription}
        toolTipDescription={tooltipDescription}
      >
        <Styled.Container style={containerStyle}>
          <Styled.Row data-testid="spacing-control-row">
            {visibleSides.map((side) => {
              const key = side.toLowerCase();
              return (
                <Styled.StepperSlot key={key}>
                  {/* ValueCounter drives its own increment/decrement/typed-edit
                      state internally and reports the final value through
                      handleChange(title, value) — that's the single write path. */}
                  <ValueCounter
                    title={side}
                    value={value[key] ?? 0}
                    handleChange={(sideKey, nextValue) =>
                      onChange(sideKey, Math.min(max, Math.max(min, Number(nextValue) || 0)))
                    }
                  />
                </Styled.StepperSlot>
              );
            })}
          </Styled.Row>
        </Styled.Container>
      </AutoScrollAccordion>

      {applyButton && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
          <Typography
            sx={{
              cursor: "pointer",
              color: "#9B5AF8",
              transition: "all 0.2s ease-in-out",
              fontSize: "16px",
              fontWeight: "500",
              fontFamily: "DM Sans",
              "&:hover": { scale: "1.05", transition: "all 0.2s ease-in-out" },
            }}
            onClick={onApplyClick}
          >
            Apply
          </Typography>
        </Box>
      )}
    </div>
  );
};

export default SpacingControl;
